import React, { useState } from 'react';
import axios from '../../config/axiosConfig'; 
import { STATES, UNION_TERRITORIES } from '../../constants/indianStates'; 

const PressMedia = () => {
  const [formData, setFormData] = useState({
    // Personal Information
    fullName: '',
    address: '',
    city: '',
    state: '',
    district: '',
    pinCode: '',
    areaWardNo: '',
    areaPoliceStation: '',
    talukOrZone: '',
    mlaConstituency: '',
    mpConstituency: '',
    mobile: '',
    whatsapp: '',
    email: '',
    dateOfBirth: '',
    gender: '',
    maritalStatus: '',
    educationQualification: '',
    nationality: '',
    natureOfBusiness: '',
    occupation: '',
    proposerName: '',
    fatherSpouseName: '',

    languagesKnown: {
            english: false,
            hindi: false,
            tamil: false,
            malayalam: false,
            telugu: false,
            kannada: false,
            other: false
          },
          otherLanguage: '',
    
    // Professional Information
    mediaHouseName: '',
    rniRegistrationNo: '',
    proprietorName: '',
    designation: '',
    officeAddress: '',
    officeCity: '',
    officeState: '',
    officePinCode: '',
    officePhone: '',
    officeEmail: '',
    frequency: '',
    chiefEditor: '',
    chiefEditorMobile: '',
    website: '',
    language: '',
    yearOfEstablishment: '',
    
    // Uploads
    idProof: null,
    photograph: null,
    signature: null,
    addressProof: null,
    
    // Declaration
    declaration: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    if (type === 'file') {
      setFormData(prev => ({
        ...prev,
        [name]: files[0]
      }));
    } else if (name.startsWith('language_')) {
      const languageId = name.replace('language_', '');
      setFormData(prev => ({
        ...prev,
        languagesKnown: {
          ...prev.languagesKnown,
          [languageId]: checked
        }
      }));
    } else if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    try {
      const submitData = new FormData();
      
      // Map frontend keys to backend snake_case keys
      const fieldMapping = {
        fullName: 'full_name',
        pinCode: 'pin_code',
        areaWardNo: 'area_ward_no',
        areaPoliceStation: 'area_police_station',
        talukOrZone: 'taluk_or_zone',
        mlaConstituency: 'mla_constituency',
        mpConstituency: 'mp_constituency',
        dateOfBirth: 'date_of_birth',
        maritalStatus: 'marital_status',
        educationQualification: 'education_qualification',
        natureOfBusiness: 'nature_of_business',
        proposerName: 'proposer_name',
        fatherSpouseName: 'father_spouse_name',
        languagesKnown: 'languages_known',
        otherLanguage: 'other_language',
        mediaHouseName: 'media_house_name',
        rniRegistrationNo: 'rni_registration_no',
        proprietorName: 'proprietor_name',
        designation: 'designation',
        officeAddress: 'office_address',
        officeCity: 'office_city',
        officeState: 'office_state',
        officePinCode: 'office_pin_code',
        officePhone: 'office_phone',
        officeEmail: 'office_email',
        chiefEditor: 'chief_editor',
        chiefEditorMobile: 'chief_editor_mobile',
        yearOfEstablishment: 'year_of_establishment',
        idProof: 'id_proof',
        addressProof: 'address_proof'
      };

      // Append all form data to FormData object
      Object.keys(formData).forEach(key => {
        const backendKey = fieldMapping[key] || key;
        
        if (key === 'languagesKnown') {
          submitData.append(backendKey, JSON.stringify(formData[key]));
        } else if (key === 'website') {
           // Auto-prepend https:// if missing
           let websiteValue = formData[key];
           if (websiteValue && !websiteValue.startsWith('http://') && !websiteValue.startsWith('https://')) {
               websiteValue = `https://${websiteValue}`;
           }
           submitData.append(backendKey, websiteValue);
        } else if (key === 'idProof' || key === 'photograph' || key === 'signature' || key === 'addressProof') {
          if (formData[key]) {
            submitData.append(backendKey, formData[key]);
          }
        } else {
          submitData.append(backendKey, formData[key]);
        }
      });

      const response = await axios.post('forms/press-media-application/', submitData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 201) {
        setMessage('Application submitted successfully! We will contact you soon.');
        setFormData({
          fullName: '',
          address: '',
          city: '',
          state: '',
          district: '',
          pinCode: '',
          areaWardNo: '',
          areaPoliceStation: '',
          talukOrZone: '',
          mlaConstituency: '',
          mpConstituency: '',
          mobile: '',
          whatsapp: '',
          email: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          educationQualification: '',
          nationality: '',
          natureOfBusiness: '',
          occupation: '',
          proposerName: '',
          fatherSpouseName: '',
          languagesKnown: {
            english: false,
            hindi: false,
            tamil: false,
            malayalam: false,
            telugu: false,
            kannada: false,
            other: false
          },
          otherLanguage: '',
          mediaHouseName: '',
          rniRegistrationNo: '',
          proprietorName: '',
          designation: '',
          officeAddress: '',
          officeCity: '',
          officeState: '',
          officePinCode: '',
          officePhone: '',
          officeEmail: '',
          frequency: '',
          chiefEditor: '',
          chiefEditorMobile: '',
          website: '',
          language: '',
          yearOfEstablishment: '',
          idProof: null,
          photograph: null,
          signature: null,
          addressProof: null,
          declaration: false
        });
        
        // Reset file inputs
        document.getElementById('idProof').value = '';
        document.getElementById('photograph').value = '';
        if (document.getElementById('signature')) document.getElementById('signature').value = '';
        if (document.getElementById('addressProof')) document.getElementById('addressProof').value = '';
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      let errorMsg = 'Error submitting application. Please try again.';
      
      if (error.response && error.response.data) {
          // If it's a simple detail error
          if (error.response.data.detail) {
              errorMsg = error.response.data.detail;
          } else {
              // If it's validation errors (dict of lists)
              const validationErrors = Object.entries(error.response.data)
                  .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`)
                  .join('\n');
              if (validationErrors) {
                  errorMsg = `Validation Error:\n${validationErrors}`;
              }
          }
      }
      setMessage(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section 
        className="relative bg-blue-900 text-white py-20 bg-cover bg-center bg-no-repeat mb-10"
        style={{ backgroundImage: "url('/images/pressmedia.webp')" }}
      >
        <div className="absolute inset-0 bg-blue-900/80"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 uppercase">
              Press Media Membership Application Form
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Fill out the form below to apply for NAI Press Media Membership
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">

        <div className='mb-6'>
            <div className='text-gray-600 text-justify'>
                By joining NAI you become part of one of the most forward thinking professional network focusing on innovation in journalism. As a NAI member, you will receive invitations to the NAI events.
If you agree with our manifesto and you affirm that you are aware of our statutes please start the membership registration process using the form below.
<br/> <br/>
<p>Print media are lightweight, portable, disposable publications printed on paper and circulated as physical copies in forms we call books, newspapers, 
    magazines and newsletters.They hold informative and entertaining content that is of general or special interest. 
    They are published either once or daily, weekly, biweekly, monthly, bimonthly or quarterly.</p>
    <br/>
Before fill the form, scan your Passport size photo, scanned copy of your signature, 
scanned copy of your any Id Proof and Address proof (Approved by central or state Government) 
keep it ready to upload.
            </div>
        </div>


        {message && (
          <div className={`mb-6 p-4 rounded-md ${
            message.includes('Error') 
              ? 'bg-red-50 text-red-700 border border-red-200' 
              : 'bg-green-50 text-green-700 border border-green-200'
          }`}>
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-lg overflow-hidden">
          {/* Personal Information Section */}
          <div className="p-6 border-b border-gray-200 mb-6">
            <h2 className="text-3xl font-semibold text-blue-800 pb-10 uppercase">
              Personal Information
            </h2>

            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="fullName" className="block text-sm font-medium text-gray-600 mb-1">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

             


              <div>
                <label htmlFor="fatherSpouseName" className="block text-sm font-medium text-gray-600 mb-1">
                  Father / Spouse Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="fatherSpouseName"
                  name="fatherSpouseName"
                  value={formData.fatherSpouseName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>    



              <div>
                <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-600 mb-1">
                  Date of Birth <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  required
                  className="w-full italic px-3 text-sm text-gray-500 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="gender" className="block text-sm font-medium text-gray-600 mb-1">
                  Gender <span className="text-red-500">*</span>
                </label>
                <select
                  id="gender"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                  className="w-full px-3 italic py-2 text-sm border text-gray-500   border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>

               <div>
                <label htmlFor="maritalStatus" className="block text-sm font-medium text-gray-600 mb-1">
                  Marital Status <span className="text-red-500">*</span>
                </label>
                <select
                  id="maritalStatus"
                  name="maritalStatus"
                  value={formData.maritalStatus}
                  onChange={handleChange}
                  required
                  className="w-full px-3 italic py-2 text-sm border text-gray-500 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select Marital Status</option>
                  <option value="married">Married</option>
                  <option value="single">Single</option>
                                  
                </select>
              </div>

                 <div>
                <label htmlFor="gender" className="block text-sm font-medium text-gray-600 mb-1">
                  Education Qualification <span className="text-red-500">*</span>
                </label>
                <select
                  id="educationQualification"
                  name="educationQualification"
                  value={formData.educationQualification}
                  onChange={handleChange}
                  required
                  className="w-full px-3 italic py-2 text-sm border text-gray-500 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select Education Qualification</option>
                  <option value="non_graduate">Non-Graduate</option>
                  <option value="diploma">Diploma</option>
                  <option value="graduate">Graduate</option>
                  <option value="post_graduate">Post Graduate</option>
                  <option value="doctorate">Doctorate</option>
                </select>
              </div>

              <div>
                <label htmlFor="mobile" className="block text-sm font-medium text-gray-600 mb-1">
                  Mobile Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div>
                <label htmlFor="whatsapp" className="block text-sm font-medium text-gray-600 mb-1">
                  Whatsapp Number 
                </label>
                <input
                  type="tel"
                  id="whatsapp"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              


              <div className="">
                <label htmlFor="email" className="block text-sm font-medium text-gray-600 mb-1">
                  Email Address 
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Language Known Section */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Languages Known <span className="text-red-500">*</span>
                </label>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                  {[
                    { id: 'english', label: 'English' },
                    { id: 'hindi', label: 'Hindi' },
                    { id: 'tamil', label: 'Tamil' },
                    { id: 'malayalam', label: 'Malayalam' },
                    { id: 'telugu', label: 'Telugu' },
                    { id: 'kannada', label: 'Kannada' },
                    { id: 'other', label: 'Other' }
                  ].map((language) => (
                    <div key={language.id} className="flex items-center">
                      <input
                        type="checkbox"
                        id={`language_${language.id}`}
                        name={`language_${language.id}`}
                        checked={formData.languagesKnown[language.id]}
                        onChange={handleChange}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <label htmlFor={`language_${language.id}`} className="ml-2 text-sm text-gray-700">
                        {language.label}
                      </label>
                    </div>
                  ))}
                </div>
                
                {/* Other Language Input */}
                {formData.languagesKnown.other && (
                  <div className="mt-3">
                    <label htmlFor="otherLanguage" className="block text-sm font-medium text-gray-700 mb-1">
                      Specify Other Language <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="otherLanguage"
                      name="otherLanguage"
                      value={formData.otherLanguage}
                      onChange={handleChange}
                      required={formData.languagesKnown.other}
                      placeholder="Enter language name"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>
                )}
              </div>
            

              <div className="md:col-span-2">
                <label htmlFor="address" className="block text-sm font-medium text-gray-600 mb-1">
                  Address <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="city" className="block text-sm font-medium text-gray-600 mb-1">
                  City <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="state" className="block text-sm font-medium text-gray-600 mb-1">
                  State <span className="text-red-500">*</span>
                </label>
                <select
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border text-sm italic text-gray-400 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select State</option>
                  <optgroup label="States">
                    {STATES.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </optgroup>
                  <optgroup label="Union Territories">
                    {UNION_TERRITORIES.map((ut) => (
                      <option key={ut} value={ut}>
                        {ut}
                      </option>
                    ))}
                  </optgroup>
                </select>
              </div>

              <div>
                <label htmlFor="district" className="block text-sm font-medium text-gray-600 mb-1">
                  District <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="district"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="pinCode" className="block text-sm font-medium text-gray-600 mb-1">
                  PIN Code <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="pinCode"
                  name="pinCode"
                  value={formData.pinCode}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div className="md:col-span-2 my-4">
                <hr className="border-blue-300 " />
              </div>
            

              <div>
                <label htmlFor="areaWardNo" className="block text-sm font-medium text-gray-600 mb-1">
                  Area Ward No / Village <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="areaWardNo"
                  name="areaWardNo"
                  value={formData.areaWardNo}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="talukOrZone" className="block text-sm font-medium text-gray-600 mb-1">
                  Taluk or Zone <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="talukOrZone"
                  name="talukOrZone"
                  value={formData.talukOrZone}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="mlaConstituency" className="block text-sm font-medium text-gray-600 mb-1">
                  MLA Constituency 
                </label>
                <input
                  type="text"
                  id="mlaConstituency"
                  name="mlaConstituency"
                  value={formData.mlaConstituency}
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div>
                <label htmlFor="mpConstituency" className="block text-sm font-medium text-gray-600 mb-1">
                  MP Constituency 
                </label>
                <input
                  type="text"
                  id="mpConstituency"
                  name="mpConstituency"
                  value={formData.mpConstituency}
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

                <div>
                <label htmlFor="areaPoliceStation" className="block text-sm font-medium text-gray-600 mb-1">
                  Area Police Station <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="areaPoliceStation"
                  name="areaPoliceStation"
                  value={formData.areaPoliceStation}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>


             <div className="md:col-span-2 my-4">
                <hr className="border-blue-300 " />
              </div>
              
            

            <div>
                <label htmlFor="natureOfBusiness" className="block text-sm font-medium text-gray-600 mb-1">
                  Nature of Business  <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="natureOfBusiness"
                  name="natureOfBusiness"
                  value={formData.natureOfBusiness}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="occupation" className="block text-sm font-medium text-gray-600 mb-1">
                  Occupation <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="occupation"
                  name="occupation"
                  value={formData.occupation}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="designation" className="block text-sm font-medium text-gray-600 mb-1">
                  Designation <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="designation"
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div>
                <label htmlFor="proposerName" className="block text-sm font-medium text-gray-600 mb-1">
                  Name of the Proposer / Introducer 
                </label>
                <input
                  type="text"
                  id="proposerName"
                  name="proposerName"
                  value={formData.proposerName} 
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

            </div>
          </div>

          {/* Professional Information Section */}
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-3xl font-semibold text-blue-800 mb-6 uppercase">
              Professional Information
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label htmlFor="mediaHouseName" className="block text-sm font-medium text-gray-700 mb-1">
                  Name of the Newspaper/Magazine * <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="mediaHouseName"
                  name="mediaHouseName"
                  value={formData.mediaHouseName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div className="md:col-span-2">
                <label htmlFor="rniRegistrationNo" className="block text-sm font-medium text-gray-700 mb-1">
                  Regd. RNI. No  <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="rniRegistrationNo"
                  name="rniRegistrationNo"
                  value={formData.rniRegistrationNo}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div className="md:col-span-2">
                <label htmlFor="proprietorName" className="block text-sm font-medium text-gray-700 mb-1">
                  Proprietor Name  <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="proprietorName"
                  name="proprietorName"
                  value={formData.proprietorName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div className="md:col-span-2">
                <label htmlFor="chiefEditor" className="block text-sm font-medium text-gray-700 mb-1">
                  Chief Editor <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="chiefEditor"
                  name="chiefEditor"
                  value={formData.chiefEditor}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div className="md:col-span-2">
                <label htmlFor="chiefEditorMobile" className="block text-sm font-medium text-gray-700 mb-1">
                  Chief Editor Mobile 
                </label>
                <input
                  type="text"
                  id="chiefEditorMobile"
                  name="chiefEditorMobile"
                  value={formData.chiefEditorMobile}
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div className="md:col-span-2">
                <label htmlFor="designation" className="block text-sm font-medium text-gray-700 mb-1">
                  Website 
                </label>
                <input
                  type="text"
                  id="website"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>


              

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Frequency <span className="text-red-500">*</span>
                </label>
                <div className="flex flex-wrap gap-4">
                  {['Daily', 'Weekly', 'Fortnightly', 'Monthly'].map((freq) => (
                    <div key={freq} className="flex items-center">
                      <input
                        type="radio"
                        id={`frequency_${freq}`}
                        name="frequency"
                        value={freq}
                        checked={formData.frequency === freq}
                        onChange={handleChange}
                        required
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                      />
                      <label htmlFor={`frequency_${freq}`} className="ml-2 text-sm text-gray-700">
                        {freq}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="md:col-span-2">
                <label htmlFor="language" className="block text-sm font-medium text-gray-700 mb-1">
                  Language 
                </label>
                <input
                  type="text"
                  id="language"
                  name="language"
                  value={formData.language}
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

               <div className="md:col-span-2">
                <label htmlFor="yearOfEstablishment" className="block text-sm font-medium text-gray-700 mb-1">
                  Year of Establishment 
                </label>
                <input
                  type="text"
                  id="yearOfEstablishment"
                  name="yearOfEstablishment"
                  value={formData.yearOfEstablishment}
                  onChange={handleChange}
                  
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>


              <div className="md:col-span-2">
                <label htmlFor="officeAddress" className="block text-sm font-medium text-gray-700 mb-1">
                  Office Address <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="officeAddress"
                  name="officeAddress"
                  value={formData.officeAddress}
                  onChange={handleChange}
                  required
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="officeCity" className="block text-sm font-medium text-gray-700 mb-1">
                  City <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="officeCity"
                  name="officeCity"
                  value={formData.officeCity}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="officeState" className="block text-sm font-medium text-gray-700 mb-1">
                  State <span className="text-red-500">*</span>
                </label>
                <select
                  id="officeState"
                  name="officeState"
                  value={formData.officeState}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2  text-sm italic text-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Select State</option>
                  <optgroup label="States">
                    {STATES.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </optgroup>
                  <optgroup label="Union Territories">
                    {UNION_TERRITORIES.map((ut) => (
                      <option key={ut} value={ut}>
                        {ut}
                      </option>
                    ))}
                  </optgroup>
                </select>
              </div>

              <div>
                <label htmlFor="officePinCode" className="block text-sm font-medium text-gray-700 mb-1">
                  PIN Code <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="officePinCode"
                  name="officePinCode"
                  value={formData.officePinCode}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="officePhone" className="block text-sm font-medium text-gray-700 mb-1">
                  Office Phone
                </label>
                <input
                  type="tel"
                  id="officePhone"
                  name="officePhone"
                  value={formData.officePhone}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="officeEmail" className="block text-sm font-medium text-gray-700 mb-1">
                  Office Email
                </label>
                <input
                  type="email"
                  id="officeEmail"
                  name="officeEmail"
                  value={formData.officeEmail}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
          </div>

          {/* Document Upload Section */}
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Document Upload
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                 <div>
                <label htmlFor="photograph" className="block text-sm font-medium text-gray-700 mb-1">
                  Recent Passport Size Photograph <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="photograph"
                  name="photograph"
                  onChange={handleChange}
                  required
                  accept=".jpg,.jpeg,.png"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Accepted formats: JPG, PNG (Max 2MB)
                </p>
              </div>

              <div>
                <label htmlFor="signature" className="block text-sm font-medium text-gray-700 mb-1">
                  Signature for ID Card <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="signature"
                  name="signature"
                  onChange={handleChange}
                  required
                  accept=".pdf,.jpg,.jpeg,.png"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Accepted formats: PDF, JPG, PNG (Max 2MB)
                </p>
              </div>
            </div>

<br/>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                 <div>
                <label htmlFor="idProof" className="block text-sm font-medium text-gray-700 mb-1">
                  ID Proof (Pan Card)  <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="idProof"
                  name="idProof"
                  onChange={handleChange}
                  required
                  accept=".jpg,.jpeg,.png"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Accepted formats: JPG, PNG (Max 2MB)
                </p>
              </div>

              <div>
                <label htmlFor="addressProof" className="block text-sm font-medium text-gray-700 mb-1">
                  Address Proof (Aadhar Card) <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  id="addressProof"
                  name="addressProof"
                  onChange={handleChange}
                  required
                  accept=".pdf,.jpg,.jpeg,.png"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Accepted formats: PDF, JPG, PNG (Max 2MB)
                </p>
              </div>

            
            </div>

  <p className='text-xs text-center text-gray-500 mt-6'>You can submit your Front and back of Aadhar card as a ID Proof as well as Address Proof.</p>

             
          </div>

          {/* Declaration Section */}
          <div className="p-6">
            <div className="flex items-start">
              <input
                type="checkbox"
                id="declaration"
                name="declaration"
                checked={formData.declaration}
                onChange={handleChange}
                required
                className="mt-1 mr-3"
              />
              <label htmlFor="declaration" className="text-sm text-gray-700">
                I hereby declare that the information provided above is true and correct to the best of my knowledge. 
                I understand that any false information may lead to rejection of my application.
              </label>
            </div>
          </div>

          {/* Submit Button */}
          <div className="px-6 py-4 bg-gray-50 text-right">
            <button
              type="submit"
              disabled={isSubmitting}
              className={`inline-flex justify-center py-3 px-6 border border-transparent shadow-sm text-sm font-medium rounded-md text-white ${
                isSubmitting 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
              }`}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Application'}
            </button>
          </div>
        </form>

        <div className="mt-6 text-center text-sm text-gray-500">
          <p>
            For any queries, please contact us at{' '}
            <a href="mailto:mail@naiindia.in" className="text-blue-600 hover:text-blue-500">
              mail@naiindia.in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PressMedia;